var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlySyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4513 14.8657L11.1596 15.1573C10.318 15.999 9.2013 16.4657 8.0013 16.4657C7.01797 16.4657 6.08464 16.149 5.31797 15.5657C5.1513 15.4407 4.99297 15.3073 4.84297 15.1573C4.69297 15.0073 4.55964 14.849 4.43464 14.6823C3.8513 13.9157 3.54297 12.9823 3.54297 11.999C3.54297 10.8073 4.0013 9.68233 4.84297 8.84066L8.80964 4.88229C9.35964 4.32396 10.043 4.01562 10.7263 4.01562H10.7346C11.3846 4.01562 12.0013 4.28229 12.518 4.79896L15.2013 7.48229C16.2846 8.56566 16.2513 10.0573 15.1263 11.199L14.5263 11.799L11.4513 14.8657Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4096 3.59792L17.943 5.12292C18.1846 5.36458 18.1846 5.76458 17.943 6.00625C17.818 6.13125 17.6596 6.18958 17.5013 6.18958C17.343 6.18958 17.1846 6.13125 17.0596 6.00625L15.968 4.91458L14.3013 6.58125L13.418 5.69792L15.0846 4.03125L13.9846 2.93958C13.743 2.69792 13.743 2.30625 13.9846 2.05625C14.2346 1.81458 14.6263 1.81458 14.868 2.05625L16.4013 3.58958H16.4096V3.59792Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0582 17.0566L4.4332 14.6816C4.5582 14.8483 4.69154 15.0066 4.84154 15.1566C4.99154 15.3066 5.14987 15.44 5.31654 15.565L2.94154 17.94C2.81654 18.065 2.6582 18.1233 2.49987 18.1233C2.34154 18.1233 2.1832 18.065 2.0582 17.94C1.81654 17.6983 1.81654 17.3066 2.0582 17.0566Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70809 12.2242C9.45809 12.4659 9.45809 12.8576 9.69975 13.1076L11.4498 14.8659L12.3414 13.9826L10.5914 12.2242C10.3414 11.9826 9.94975 11.9826 9.70809 12.2242Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.0411C10.75 9.79948 10.75 9.40781 11 9.15781C11.2417 8.91615 11.6417 8.91615 11.8833 9.15781L14.525 11.7995L13.6417 12.6828L11 10.0411Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlySyringe);
export default __webpack_public_path__ + "static/media/iconly_syringe.33e1eba4562dfcb4dc5a9a91d72e978f.svg";
export { ForwardRef as ReactComponent };